import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  FxFlexDirective,
  FxLayoutAlignDirective,
  FxLayoutDirective,
  FxLayoutGapDirective,
  InformationDialogComponent,
  ResponsiveService,
} from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-free-pickups-split-landing',
  templateUrl: './free-pickups.component.html',
  styleUrl: './free-pickups.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, StarRatingModule],
})
export class FreePickupsComponent extends BaseSectionComponent {
  get isDescriptionShorthend() {
    return this.isSmallWindowSize && this.options?.text?.length > 500;
  }

  get shortText() {
    return (this.isDescriptionShorthend ? this.options?.text?.substring(0, 500) + '...' : this.options?.text || '').replaceAll(
      '\n',
      '</br>',
    );
  }

  constructor(
    private dialog: MatDialog,
    public override responsiveService: ResponsiveService,
  ) {
    super(responsiveService);
  }

  showText() {
    this.dialog.open(InformationDialogComponent, {
      width: '90vw',
      height: '80vh',
      data: {
        title: this.options?.title,
        message: this.options?.text?.replaceAll('\n', '</br>'),
        button: 'I understand',
      },
    });
  }
}
